import axios from 'axios';

axios.defaults.headers = {
  Authorization: 'Bearer ' + localStorage.getItem('token'),
  Accept: 'application/json',
};

const state = {
  registryList: null,
};

const getters = {
  registryList: state => state.registryList,
};

const actions = {
  getRegistryList: async ({ commit }, payload = {}) => {
    if (!payload?.db_counterparty_id) {
      return {
        status: false,
        data: { success: false, message: 'db_counterparty_id is required.' },
      };
    }
    try {
      const result = await axios.post('/np/loadRegisterNp', payload);
      commit('changeRegistryList', result.data);
      return {
        status: true,
        data: result.data,
      };
    } catch (e) {
      return {
        status: false,
        data: e?.response?.data ?? { success: false, message: e?.message ?? 'Error loading registers' },
      };
    }
  },

  loadRegister: async (ctx, payload = {}) => {
    if (!payload?.db_counterparty_id) {
      return {
        status: false,
        data: { success: false, message: 'db_counterparty_id is required.' },
      };
    }
    if (!payload?.ref) {
      return {
        status: false,
        data: { success: false, message: 'ref is required.' },
      };
    }
    try {
      const result = await axios.post('/np/loadRegisterNp', payload);
      return {
        status: true,
        data: result.data,
      };
    } catch (e) {
      return {
        status: false,
        data: e?.response?.data ?? { success: false, message: e?.message ?? 'Error loading register' },
      };
    }
  },
};

const mutations = {
  changeRegistryList(state, status) {
    state.registryList = status;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

